import * as React from 'react';

import type { SalesLoadLineItemPhase } from '@rematter/frontend-lib-api-client';
import type { LoadFormLineItem } from '@rematter/modules/trade/types/load';

type Props = {
  lineItems: LoadFormLineItem[];
  loadPhaseType: SalesLoadLineItemPhase;
};

export const useLineItemPhases = ({ lineItems, loadPhaseType }: Props) => {
  const lineItemsByPhase = React.useMemo(
    () =>
      lineItems.filter((item) => {
        if (!item.phase) {
          return true;
        }
        return item.phase === loadPhaseType;
      }),
    [lineItems, loadPhaseType],
  );

  return { lineItemsByPhase };
};
